import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Contract } from 'src/app/modules/acbcr/common/models/contract.model';
import { ContractTableService } from 'src/app/modules/acbcr/common/services/contracts-table.service';
import { Store, select } from '@ngrx/store';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { distinctUntilChanged, filter, switchMap, takeUntil } from 'rxjs/operators';
import { getLoadingState, getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';

@Component({
  selector: 'app-contract-tab',
  templateUrl: './contract-tab.component.html',
  styleUrls: ['./contract-tab.component.scss']
})
export class ContractTabComponent implements OnInit, OnDestroy {

  tables$: Observable<Contract[]>;
  total$: Observable<number>;
  loadingDataSpinner = false;

  objToAPI = {
    comp_id: null,
    comp_code: '',
    page_no: '1',
    page_size: '10',
    contr_status: 3,
  };

  destroy$: Subject<boolean> = new Subject<boolean>();
  selectedHolding;

  constructor(
    public contractsTableService: ContractTableService,
    private store: Store<ApplicationState>
  ) {
    this.tables$ = contractsTableService.tables$;
    this.total$ = contractsTableService.total$;
  }

  ngOnInit(): void {
    this.store.pipe(
      select(getLoadingState),
      filter(isLoading => !isLoading),
      switchMap(() => this.store.pipe(select(getSelectedHolding))),
      distinctUntilChanged((prev, curr) => prev.id === curr.id),
      takeUntil(this.destroy$),
    ).subscribe((response: any) => {
        this.selectedHolding = response;

        if (this.selectedHolding !== undefined && this.selectedHolding.id > 0) {
          this.getTableData();
        }
      });
  }

  // Get table data only for selected holding
  getTableData() {
    this.objToAPI.comp_code =
      this.selectedHolding !== undefined ? this.selectedHolding.code : '';

    this.loadingDataSpinner = true;
    this.contractsTableService
      .getContractsAPI(this.objToAPI).subscribe((response) => {
        // Hide spinner, after 1 second
        setTimeout(() => {
          this.loadingDataSpinner = false;
        }, 500);
      });
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  filterSearchData(event) {
    // Compose the object what will be sended to the back-end
    this.objToAPI = {
      ...this.objToAPI,
      ...event,
    };

    this.getTableData();
  }

  changePageSize(event) {
    this.objToAPI.page_size = event;
    this.getTableData();
  }

  changePageNumber(event) {
    this.objToAPI.page_no = event;
    this.getTableData();
  }

  getCallbackResult(event) {
    this.getTableData();
  }

}
